<div class="video-background">
    <video *ngIf="video != undefined" controls="" autoplay="" name="media" class='video'>
       <source id ="video-source" [src]="video" type="video/mp4">
    </video>
</div>